module.exports = __webpack_public_path__ + "r-v3/img/ml_05_01.54cd6cde.jpg";